import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffectiveSetList } from '@/hooks/useEffectiveSetList';
import SetListItem from './SetListItem';
import CreateSetModal from './CreateSetModal';
import Spinner from '@/components/common/Spinner';
import Button from '@/components/common/Button';

export default function SetList() {
  const { sets, isLoading, error } = useEffectiveSetList();
  const [showCreateSetModal, setShowCreateSetModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-neutral-200 p-4">
        <h2 className="text-sm font-semibold text-neutral-700">Sets</h2>
        <Button
          variant="primary"
          size="sm"
          onClick={() => setShowCreateSetModal(true)}
        >
          + New Set
        </Button>
      </div>

      {/* Set list */}
      <div className="flex-1 overflow-y-auto">
        {isLoading && <Spinner className="py-8" />}

        {error && (
          <div className="p-4 text-center text-sm text-error-600">
            Failed to load sets
          </div>
        )}

        {!isLoading && !error && sets.length === 0 && (
          <div className="flex flex-1 flex-col items-center justify-center px-4 py-12">
            <svg className="h-12 w-12 text-neutral-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
              />
            </svg>
            <div className="mt-4 text-center">
              <p className="mb-3 text-sm text-neutral-500">No sets yet</p>
              <Button
                variant="primary"
                size="sm"
                onClick={() => setShowCreateSetModal(true)}
              >
                Create your first set
              </Button>
            </div>
          </div>
        )}

        {sets.map((set) => (
          <SetListItem
            key={set.set_id}
            set={set}
            onClick={() => navigate(`/app/sets/${set.set_id}`)}
          />
        ))}
      </div>

      {/* Create Set Modal */}
      <CreateSetModal
        isOpen={showCreateSetModal}
        onClose={() => setShowCreateSetModal(false)}
      />
    </div>
  );
}
